import React from 'react';
import { ServicePage } from '../ServicePage';

const CONFIG = {
  title: 'Réparation iPhone Villeurbanne / Lyon — Express 15min | PHONELAB 69',
  metaDescription: '✅ Réparation iPhone Villeurbanne & Lyon Métropole. Tous modèles iPhone 11 à 16. Écran, batterie, connecteur, caméra. Express 15min. Garantie 12 mois. ☎ 04 26 00 82 10',
  icon: '📱',
  badge: 'Spécialiste iPhone — Villeurbanne / Lyon',
  h1: 'Réparation iPhone\nVilleurbanne & Lyon',
  subtitle: 'Tous les modèles iPhone réparés en express. Pièces d\'origine en stock, garantie jusqu\'à 12 mois, diagnostic 100% gratuit.',
  stats: [
    { icon: '⚡', label: 'Écran en 15 min' },
    { icon: '🛡️', label: 'Garantie 12 mois' },
    { icon: '✅', label: 'Diagnostic GRATUIT' },
    { icon: '📦', label: 'Pièces en stock' },
  ],
  servicesTitle: 'Réparations iPhone disponibles à Villeurbanne',
  services: [
    { icon: '📺', name: 'Remplacement écran iPhone', models: 'iPhone 11, 12, 13, 14, 15, 16 — toutes versions', duration: '15 à 30 min' },
    { icon: '🔋', name: 'Remplacement batterie iPhone', models: 'Batterie certifiée, capacité restaurée à 100%', duration: '15 min' },
    { icon: '⚡', name: 'Réparation connecteur de charge', models: 'Lightning & USB-C — iPhone 15+', duration: '20 min' },
    { icon: '📷', name: 'Réparation caméra iPhone', models: 'Caméra avant, arrière, ultra-grand-angle', duration: '20-30 min' },
    { icon: '🔘', name: 'Boutons & Face ID', models: 'Bouton Home, Power, Volume, Face ID', duration: '30-45 min' },
    { icon: '🔧', name: 'Micro-soudure carte mère', models: 'Problèmes d\'alimentation, données récupération', duration: '24-48h' },
    { icon: '💧', name: 'Désoxydation iPhone noyé', models: 'Nettoyage ultrason — résultat non garanti', duration: '1-2h' },
    { icon: '🔲', name: 'Vitre arrière iPhone', models: 'iPhone 8, X, 11, 12, 13, 14 — laser ou remplacement', duration: '30-60 min' },
    { icon: '🔊', name: 'Haut-parleur & micro', models: 'Problèmes d\'appel, musique, Siri', duration: '20 min' },
  ],
  guarantee: {
    duration: 'Garantie 12 mois',
    label: 'Pièces d\'origine Service Pack',
    speed: 'Express 15-30 min',
  },
  faq: [
    {
      q: 'Combien coûte la réparation d\'un écran iPhone à Villeurbanne ?',
      a: 'Le tarif varie selon le modèle iPhone (de l\'iPhone 11 à l\'iPhone 16 Pro Max) et la qualité de l\'écran choisie. PHONELAB 69 propose plusieurs gammes (entrée, premium, origine) avec des prix toujours compétitifs. Diagnostic et devis 100% gratuits — venez nous voir ou appelez le 04 26 00 82 10.',
    },
    {
      q: 'La réparation iPhone est-elle possible sans rendez-vous à Villeurbanne ?',
      a: 'Oui ! PHONELAB 69 accepte les clients sans rendez-vous du lundi au samedi. Passez directement au 6 Rue Paul Verlaine (Tram T6, Gratte-Ciel). Pour les pannes complexes (carte mère), un rendez-vous est recommandé.',
    },
    {
      q: 'Quelle garantie sur la réparation de mon iPhone ?',
      a: 'La garantie dépend de la pièce choisie : 12 mois sur les pièces d\'origine (Service Pack), 6 mois sur les compatibles premium, 3 mois minimum sur l\'entrée de gamme. En cas d\'immobilisation > 7 jours, la garantie est prolongée (Art. L217-11).',
    },
    {
      q: 'Réparez-vous les iPhone récents (iPhone 15, 16) à Villeurbanne ?',
      a: 'Oui, PHONELAB 69 répare tous les modèles y compris les plus récents : iPhone 15, 15 Pro, 15 Pro Max, iPhone 16, 16 Plus, 16 Pro. Pièces en commande rapide si non en stock.',
    },
    {
      q: 'Peut-on réparer un iPhone qui ne s\'allume plus ?',
      a: 'Dans la plupart des cas, oui. Un iPhone qui ne s\'allume plus est souvent une panne de batterie (80% des cas) ou une coupure d\'alimentation. Notre diagnostic gratuit identifie précisément le problème avant tout devis.',
    },
  ],
  ctaTitle: 'Votre iPhone réparé aujourd\'hui',
  ctaSubtitle: 'Sans rendez-vous · Express 15 min · Diagnostic gratuit',
};

export default function IphonePage() {
  return <ServicePage config={CONFIG} />;
}
